/** Keep variant-dependent specifications and truthful stock text aligned with native Shopify variant changes. */
import { StandardEvents } from '@shopify/events';
class LavryaProductState extends HTMLElement {
  #section;
  #generation = 0;
  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }
  disconnectedCallback() {
    this.#generation++;
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise || typeof event.promise.then !== 'function') return;
    const generation = ++this.#generation;
    // Do not display the previous variant's stock while the new selection loads.
    this.querySelectorAll('[data-lv-stock], [data-lv-specs]').forEach((node) => { node.hidden = true; });
    this.setAttribute('aria-busy', 'true');
    event.promise.then(({ detail }) => {
      if (!this.isConnected || generation !== this.#generation || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const source = detail.html.querySelector(`lavrya-product-state[data-block-id="${CSS.escape(this.dataset.blockId || '')}"]`);
      if (!source) return;
      // Preserve the customer's accordion state when its content still exists.
      const states = Array.from(this.querySelectorAll('details')).map((node) => node.open);
      this.replaceChildren(...Array.from(source.childNodes, (node) => node.cloneNode(true)));
      this.querySelectorAll('details').forEach((node, index) => {
        if (index < states.length) node.open = states[index];
      });
      this.dataset.productId = source.dataset.productId || this.dataset.productId;
      if (!detail.resource?.id) this.querySelectorAll('[data-lv-stock], [data-lv-specs]').forEach((node) => { node.hidden = true; });
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[LAVRYA] Variant details could not be refreshed.');
    }).finally(() => {
      if (generation === this.#generation) this.removeAttribute('aria-busy');
    });
  };
}
if (!customElements.get('lavrya-product-state')) customElements.define('lavrya-product-state', LavryaProductState);
